import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { Graph } from 'schema-dts';
import { LocaleAllow } from '../../../types/IHeader';
import { HeadWrapperProps } from '../HeadWrapper';
import { jsonDecodeAllSchema } from './functions/parseSchema';
import FactorySchema from './schema';
import { PostMeta } from '../utils';
export const siteUrl = 'https://payfit.com';

export const findLocalCode = (key: LocaleAllow): string => {
  const allLocaleCode = {
    fr: 'fr-FR',
    en: 'en-GB',
    es: 'es-ES',
  };
  return allLocaleCode[key];
};

export const findLocalSlug = (key: LocaleAllow): string => {
  const allLocaleCode = {
    fr: 'fr/',
    en: '',
    es: 'es/',
  };
  return allLocaleCode[key];
};

export const SchemaOrg = ({
  data,
  dataName,
  templateName,
  pageContext,
  location,
  postMeta,
}: Omit<HeadWrapperProps, 'largestContentfullPaintImg'> & {
  postMeta: PostMeta;
}) => {
  const { pathname: uri } = location;
  const { locale } = pageContext;
  const datoCmsSchemaMarkupAllLocale: { [key: string]: any } = useStaticQuery(
    graphql`
      query MyQuery {
        fr: allDatoCmsSchemaMarkup(locale: "fr") {
          nodes {
            json
          }
        }
        en: allDatoCmsSchemaMarkup(locale: "en") {
          nodes {
            json
          }
        }
        es: allDatoCmsSchemaMarkup(locale: "es") {
          nodes {
            json
          }
        }
      }
    `,
  );

  const dataPage = data[dataName];
  const schemaFromDato = datoCmsSchemaMarkupAllLocale?.[locale].nodes;

  if (schemaFromDato && typeof schemaFromDato === 'object') {
    const allSchema = jsonDecodeAllSchema(schemaFromDato);
    const softwareSchema = allSchema?.find(
      (item) => item?.['@type'] === 'SoftwareApplication',
    );

    const dataWithBreadcrumb =
      data && ('datoCmsBlogHome' in data || 'SubcategoryPage' in data)
        ? data.datoCmsBlogHome
        : null;

    const factJsonLd = new (FactorySchema as any)();

    const jsonLd = new factJsonLd.CreateElement(
      dataPage,
      locale,
      uri,
      allSchema,
      dataWithBreadcrumb,
      postMeta,
    );

    const isHomePage = pageContext.slug === 'home';

    const collectionPage = [
      'AllClientsPage',
      'BlogHomepage',
      'CategoryPage',
      'EventsPage',
      'SubcategoryPage',
    ];
    const article = ['BlogArticle', 'ClientPage'];
    const aboutUsTemplate = ['WhyPayFitPage'];
    const aboutUsSlugs = [
      'about-us',
      'notre-histoire',
      'ueber',
      'sobre-nosotros',
    ];

    const payfitProduct = ['PricingPageV3'];
    if (collectionPage.includes(templateName)) {
      jsonLd.addCollectionPage();
    } else if (article.includes(templateName)) {
      jsonLd.addArticle();
    }
    if (
      aboutUsTemplate.includes(templateName) ||
      aboutUsSlugs.includes(data[dataName].slug)
    ) {
      jsonLd.addAboutUs();
    }
    if (payfitProduct.includes(templateName)) {
      jsonLd.addPayfitProduct();
    }
    if (isHomePage && softwareSchema) {
      jsonLd.addSoftwareApplication(softwareSchema);
    }

    if (dataPage?.faq) {
      dataPage.faq.map((faq: any) => {
        jsonLd.addFAQ(faq.faqQuestionsAnswers, faq.id);
      });
    }

    if ('blocks' in dataPage) {
      const blocks = dataPage?.blocks;
      if (Array.isArray(blocks)) {
        blocks.forEach((block, index) => {
          if (block?.__typename === 'DatoCmsFaq') {
            jsonLd.addFAQ(block.faqQuestionsAnswers, block.id);
          }

          if (block?.__typename === 'DatoCmsVideo') {
            jsonLd.addVideo(block, 'trackingVideo', index);
          }
          if (block?.__typename === 'DatoCmsTablePriceBlock') {
            jsonLd.addTablePrices(block, 'trackingVideo', index);
          }
        });
      }
    }

    const schema: Graph = {
      '@context': 'https://schema.org',
      '@graph': jsonLd.getSchema(),
    };

    return <script type="application/ld+json">{JSON.stringify(schema)}</script>;
  }
  return <></>;
};
